var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("validation-observer", {
    ref: "validator",
    scopedSlots: _vm._u(
      [
        {
          key: "default",
          fn: function(ref) {
            var valid = ref.valid
            return [
              _c(
                "b-form",
                {
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.submit($event)
                    },
                    reset: function($event) {
                      $event.preventDefault()
                      return _vm.clear($event)
                    }
                  }
                },
                [
                  _c("validation-provider", {
                    attrs: { name: "name", rules: "required" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(validationContext) {
                            return [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-1",
                                    label: "Nome:",
                                    "label-for": "list-name"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "list-name",
                                      type: "text",
                                      state: _vm.getValidationState(
                                        validationContext
                                      )
                                    },
                                    model: {
                                      value: _vm.name,
                                      callback: function($$v) {
                                        _vm.name = $$v
                                      },
                                      expression: "name"
                                    }
                                  }),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(
                                      " " +
                                        _vm._s(validationContext.errors[0]) +
                                        " "
                                    )
                                  ])
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  }),
                  _c("validation-provider", {
                    attrs: { name: "description" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(validationContext) {
                            return [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-1",
                                    label: "Descrição:",
                                    "label-for": "list-description"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "list-description",
                                      type: "text",
                                      state: _vm.getValidationState(
                                        validationContext
                                      )
                                    },
                                    model: {
                                      value: _vm.description,
                                      callback: function($$v) {
                                        _vm.description = $$v
                                      },
                                      expression: "description"
                                    }
                                  }),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(
                                      " " +
                                        _vm._s(validationContext.errors[0]) +
                                        " "
                                    )
                                  ])
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  }),
                  _vm.showSubmit || _vm.showReset
                    ? _c(
                        "b-form-row",
                        { staticClass: "justify-end" },
                        [
                          _vm.showSubmit
                            ? _c(
                                "b-col",
                                { attrs: { cols: "auto" } },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        disabled: !valid,
                                        type: "submit",
                                        variant: "primary"
                                      }
                                    },
                                    [
                                      _vm._t("submit-button-text", [
                                        _vm._v("Salvar")
                                      ])
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.showReset
                            ? _c(
                                "b-col",
                                { attrs: { cols: "auto" } },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        type: "reset",
                                        variant: "outline-secondary"
                                      }
                                    },
                                    [
                                      _vm._t("reset-button-text", [
                                        _vm._v("Limpar")
                                      ])
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          }
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }